import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({ standalone: false,
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',

  styleUrls: ['./error-page.component.css']
})
export class ErrorPageComponent {

  @Input("code") code!: string;
  @Input("title") title!: string;
  @Input("subtitle") subtitle!: string;

  constructor() {}

}
